import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Dashboard, DashboardCardGroup } from "../../../../dashboards/components/Dashboard"
import { PosSalesCards } from "../components/PosSalesCards"
import { ControlCodeCard } from "../components/ControlCodeCard"
import { OrderSummaryCards } from "../components/OrderSummaryCards"
import { MeetingServiceInfo } from "../components/MeetingServiceInfo"
import { TodaysOffersCard } from "../components/TodaysOffersCard"
import { CardGroup } from "../components/CardGroup"
import { MatchEnvironment } from "../../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../../environment/envTypes"
import { DeviceReport } from "../components/DeviceReport"
import { Statistics } from "../components/Statistics/Statistics"

type MerchantHomeProps = Readonly<{}>

export function MerchantReportsHome({}: MerchantHomeProps) {
    return (
        <Dashboard>
            <DeviceReport />

            <CardGroup>
                <ControlCodeCard />
                <TodaysOffersCard />
            </CardGroup>

            <LocalizedStrict id="merchant-home-today-card-group" attrs={{ title: true, subtitle: true }}>
                <DashboardCardGroup title="POS Sales" subtitle="today">
                    <PosSalesCards />
                </DashboardCardGroup>
            </LocalizedStrict>


            <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}>
                <LocalizedStrict id="merchant-home-meeting-service-card-group" attrs={{ title: true, subtitle: true }}>
                    <DashboardCardGroup title="Meeting service" subtitle="Today">
                        <OrderSummaryCards />
                    </DashboardCardGroup>
                </LocalizedStrict>

                <MeetingServiceInfo />
            </MatchEnvironment>

            <Statistics />
        </Dashboard>
    )
}
